// extracted by mini-css-extract-plugin
module.exports = {"section":"Section_section__gjwvr","sectionContent":"Section_sectionContent__8WkeC","sectionIcon":"Section_sectionIcon__7e6wJ"};